import { convexQuery } from "@convex-dev/react-query";
import { api } from "@slapinc/slappos-backend/api";

/**
 * Query options for fetching user's organizations
 * Returns empty array for new users not yet in the database
 */
export const organizationsQueryOptions = () =>
	convexQuery(api.features.organizations.web.list, {});

/**
 * Query options for fetching the current user
 * Returns null if user is not authenticated or not in database
 */
export const meQueryOptions = () => convexQuery(api.features.users.web.me, {});
